<template>
  <div class="bindPhone">
    <div class="back_icon_box" @click="back">
      <van-icon name="arrow-left" size="24" />
    </div>

    <div class="title_box">
      <div class="text1">绑定手机号</div>
      <div class="text2">为了更好的服务您，请绑定手机号</div>
    </div>

    <div class="phone_input_box">
      <van-field
        v-model="tel"
        type="tel"
        label=""
        maxlength="11"
        placeholder="请输入手机号"
      />
    </div>

    <div class="btn_box" :class="{active: tel.length === 11}" @click="sendCode">
      获取短信验证码
    </div>
  </div>
</template>

<script>
import { Icon, Field, Toast } from 'vant'
import { validMobile } from '@/utils/validate.js'

import { ApiSendCode } from '@/api/login.js'

export default {
  name: 'bindPhone',
  components: {
    vanIcon: Icon,
    vanField: Field,
  },
  data() {
    return {
      tel: '',
      loading: false
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    sendCode() {
      if (this.loading) return false

      if (this.tel.length < 11) return false

      if (!validMobile(this.tel)) {
        Toast('手机号格式不正确')

        return false
      }

      this.loading = true
      ApiSendCode({
        phone: this.tel
      }).then(res => {
        this.loading = false
        Toast(res.msg)
        if (res.code === 200) {
          this.$router.push({ path: 'smsCode', query: { tel: this.tel } })
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
.bindPhone {
  .van-field {
    padding: 0
  }
}
</style>

<style lang="scss" scoped>
@import '../../assets/css/flexable.scss';

.bindPhone {
  position: relative;
  .back_icon_box {
    position: absolute;
    top: px2rem(33);
    left: px2rem(33);
    z-index: 1;
  }

  .title_box {
    margin-bottom: px2rem(120);
    width: 100%;
    padding-top: px2rem(170);
    padding-left: px2rem(70);
    text-align: left;
    box-sizing: border-box;
    .text1 {
      margin-bottom: px2rem(25);
      font-size: px2rem(48);
      font-weight: bold;
      color: #1F1F1F;
      line-height: 1;
    }
    .text2 {
      font-size: px2rem(34);
      font-weight: 500;
      color: #1F1F1F;
      line-height: 1;
    }
  }

  .phone_input_box {
    margin: 0 auto;
    margin-bottom: px2rem(70);
    width: px2rem(610);
    padding-bottom: px2rem(20);
    border-bottom: 1px solid #F5F5F9;
  }

  .btn_box {
    margin: 0 auto;
    width: px2rem(610);
    height: px2rem(96);
    line-height: px2rem(96);
    text-align: center;
    font-size: px2rem(32);
    font-weight: bold;
    color: #fff;
    border-radius: px2rem(10);
    background-color: #D0D0D1;
    &.active {
      background-color: #16151b;
    }
  }
}
</style>